import { useQuery } from '@tanstack/react-query';

import { GetTelemetryCreditItemsResponse, PurchasableItem } from '@/api/subscriptions/types';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';

export const getTelemetryCreditItems = async (options?: RequestOptions) => {
    const items = await axios.get<GetTelemetryCreditItemsResponse, GetTelemetryCreditItemsResponse>(
        '/api/v2/subscriptions/telemetry-credit-items',
        options
    );
    return items.data;
};

type UseTelemetryCreditItemsOptions = {
    config?: QueryConfig<typeof getTelemetryCreditItems>;
};

export const useTelemetryCreditItems = ({ config }: UseTelemetryCreditItemsOptions = {}) => {
    return useQuery<PurchasableItem[]>({
        ...config,
        queryKey: ['get-telemetry-credit-items'],
        queryFn: ({ signal }) => getTelemetryCreditItems({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
